interface DayMenuItemProps {
  icon: string;
  title: string;
  color?: string;
  onClick?: () => void;
}

export function DayMenuItem({ icon, title, color, onClick }: DayMenuItemProps) {
  return (
    <div
      onClick={onClick}
      className="flex flex-row items-center gap-2.5 px-2.5 my-[9px]   cursor-pointer text-nowrap "
    >
      <i
        className={`ki-duotone ki-${icon} text-xl`}
        style={{ color: color || "inherit" }}
      ></i>
      <span>{title}</span>
    </div>
  );
}
